import React, { useState, useEffect, useCallback } from 'react';
import { registerNotificationHandler } from './util/NotificationManager';
import './notification.css';

const NotificationContainer = () => {
  const [notification, setNotification] = useState(null);
  const [timerId, setTimerId] = useState(null);

  // Limpia cualquier notificación anterior antes de mostrar una nueva
  const handleNewNotification = useCallback((data) => {
    setNotification(data);

    if (timerId) clearTimeout(timerId);

    const id = setTimeout(() => {
      setNotification(null);
    }, data.duration || 3000);

    setTimerId(id);
  }, [timerId]);

  useEffect(() => {
    registerNotificationHandler(handleNewNotification);
  }, [handleNewNotification]);

  const handleClose = () => {
    if (timerId) clearTimeout(timerId);
    setNotification(null);
  };

  if (!notification) return null;

  return (
    <div className={`notification ${notification.type}`}>
      <p>{notification.message}</p>
      <p className="close-btn" onClick={handleClose}>×</p>
    </div>
  );
};

export default NotificationContainer;